import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './useModalAddNewGame.module.scss';
import clsx from 'clsx';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Input from '../Input/Input';
import { useForm } from 'react-hook-form';
import Button from '../Button/Button';
import PartnerNewGameAdd from '../PartnerNewGameAdd/PartnerNewGameAdd';
import { gamePartnerCreate } from '../../redux/actions/game/gamePartnerCreate';
const ReactSwal = withReactContent(Swal);
const useModalAddNewGame = (onSuccess) => {
  const [show, setShow] = useState(false);
  const open = () => {
    setShow(true);
  };
  const dispatch = useDispatch();

  const {
    gamePartnerCreate: { data: gamePartnerCreateData, loading: gamePartnerCreateLoading, error: gamePartnerCreateError },
  } = useSelector((state) => state.game);
  useEffect(() => {
    if (gamePartnerCreateData) {
      onSuccess();
      ReactSwal.close();
    }
  }, [gamePartnerCreateData]);

  useEffect(() => {
    if (show) {
      ReactSwal.fire({
        title: `Добавить новую игру`,
        html: (
          <div>
            <PartnerNewGameAdd
              onCreate={(data) => {
                dispatch(gamePartnerCreate(data));
              }}
            />
          </div>
        ),

        showCancelButton: false,
        showConfirmButton: false,
        background: '#fff',
        cancelButtonColor: 'rgb(131, 131, 131)',
        cancelButtonText: 'Закрыть',
        confirmButtonColor: '#65c15c',
        confirmButtonText: 'Добавить',
      })
        .then((result) => {
          // if (result.isConfirmed) {
          //   return Promise.reject;
          // } else {
          //   // setShow(false);
          // }
        })
        .finally(() => {
          setShow(false);
        });
    }
  }, [show]);

  return { open };
};

export default useModalAddNewGame;
